import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useMemo } from 'react';
import BaseViewer from './Base';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/journal.scss';
const JournalViewer = (_param)=>{
    var { theme: themeFromProps , fixedParagraph =true  } = _param, restProps = _object_without_properties(_param, [
        "theme",
        "fixedParagraph"
    ]);
    const theme = useMemo(()=>mergeTheme(baseTheme, themeFromProps), [
        themeFromProps
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-journal'
    }, /*#__PURE__*/ React.createElement(BaseViewer, _extends({
        theme: theme,
        fixedParagraph: fixedParagraph
    }, restProps)));
};
JournalViewer.displayName = 'JournalViewer';
export default JournalViewer;
